import { render, staticRenderFns } from "./AddAuthorizationDocumentDialog.vue?vue&type=template&id=880de956&"
import script from "./AddAuthorizationDocumentDialog.vue?vue&type=script&lang=js&"
export * from "./AddAuthorizationDocumentDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports